import { useId } from "react";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import { SettingsPanelRow, SettingsPanelSeparator } from "./SettingsPanelParts";

interface DensityRowProps<T extends string> {
    options: ReadonlyArray<{ value: T; label: string }>;
    value: T;
    onChange: (value: T) => void;
}

/** A table gear's Density row, after a separator: a segmented pick of `options`. */
export const DensityRow = <T extends string>({
    options,
    value,
    onChange,
}: Readonly<DensityRowProps<T>>) => {
    const labelId = useId();
    return (
        <>
            <SettingsPanelSeparator />
            <SettingsPanelRow label="Density" labelId={labelId}>
                <ToggleGroup.Root<T>
                    variant="segmented"
                    size="sm"
                    aria-labelledby={labelId}
                    value={value}
                    onValueChange={(next) => {
                        if (next !== null) {
                            onChange(next);
                        }
                    }}
                >
                    {options.map((option) => (
                        <ToggleGroup.Item
                            key={option.value}
                            value={option.value}
                        >
                            {option.label}
                        </ToggleGroup.Item>
                    ))}
                </ToggleGroup.Root>
            </SettingsPanelRow>
        </>
    );
};
